import { ZoomIn, ZoomOut } from '@/asset/icon';
import { VFlex } from '@/package';
import { useLabelingBoxContext } from '@/provider';
import { useToolSurfaceCameraStore } from '@/store';

import { useToolPcdCanvasContext } from './hook';

const ToolPcdCanvasZoomController = () => {
  const { selectedLabelingBoxList } = useLabelingBoxContext();
  const { viewMode, isViewMode } = useToolPcdCanvasContext();
  const { cameraMap, setZoom } = useToolSurfaceCameraStore();
  const selectedBox = selectedLabelingBoxList?.[0];
  const zoomControllerButtonList = [
    {
      Icon: ZoomIn,
      onClick: () => {
        setZoom(viewMode, (cameraMap as any)[viewMode].zoom + 10);
      },
    },
    {
      Icon: ZoomOut,
      onClick: () => {
        setZoom(viewMode, (cameraMap as any)[viewMode].zoom - 10);
      },
    },
  ];

  return (
    <VFlex
      justify="end"
      items="center"
      gap={0.5}
      className="h-12 w-full bg-black p-2"
    >
      <VFlex className="flex-1 gap-1 pl-2">
        <div className="text-white uppercase">{viewMode}</div>
        {selectedBox && (
          <div className="text-white">
            #{selectedBox.getShortenTrackId() ?? selectedBox.id.slice(0, 8)}
          </div>
        )}
      </VFlex>

      {selectedLabelingBoxList.length === 1 && selectedBox && (
        <VFlex
          items="center"
          justify="center"
          gap={0.25}
          className="text-white"
        >
          {(isViewMode.top || isViewMode.side) && (
            <div className="text-body-sm">
              <span>L&nbsp;:&nbsp;</span>
              <span>{+selectedBox.dimension[0].toFixed(2)}</span>
            </div>
          )}

          {(isViewMode.top || isViewMode.front) && (
            <div className="text-body-sm">
              <span>W&nbsp;:&nbsp;</span>
              <span>{+selectedBox.dimension[1].toFixed(2)}</span>
            </div>
          )}

          {(isViewMode.side || isViewMode.front) && (
            <div className="text-body-sm">
              <span>H&nbsp;:&nbsp;</span>
              <span>{+selectedBox.dimension[2].toFixed(2)}</span>
            </div>
          )}
        </VFlex>
      )}

      {zoomControllerButtonList.map((Button, i) => {
        return (
          <button
            key={i}
            className="rounded-md bg-black p-2 transition-colors hover:bg-bg-dark active:bg-gray-600"
            onClick={Button.onClick}
          >
            <Button.Icon className="h-4 w-4 stroke-white" />
          </button>
        );
      })}
    </VFlex>
  );
};

export default ToolPcdCanvasZoomController;
